<div class="app-brand-logo-container d-flex align-items-center" [class]="className"
  [class.text-white]="color === 'light'">
  <img [src]="'/assets/images/logos/logo-market.svg'" alt="MarketConnector"
    style="max-width: 100%; max-height: 48px; width: auto;" />
  <!-- Sempre no DOM + escondido por classe (não @if): assim o CSS do drawer mobile consegue
       forçar o texto visível mesmo com showText=false (colapso é conceito de desktop). -->
  <span class="app-brand-text ms-2" [class.app-brand-text--collapsed]="!showText"
    [class.text-white]="color === 'light'">
    <span class="brand-word-1">Market</span>
    <span class="brand-word-2">Connector</span>
  </span>
</div>